import CardBody from '@/components/index/cardbody/index.vue' //标题卡槽
import noData from '@/components/noData/index.vue' //暂无数据
import {selectData} from '@/assets/js/selectList.js';
import selectBox from '@/components/selectBox/index.vue'
import Popup from '@/components/popup/index.vue'
import {dataSource} from "@/api/api";
export default {
	name: 'project',
	components: { //注册组件
		CardBody,
		selectBox,
		Popup,
		noData
	},
	data() {
		return {
			name:'',
			name1:'',
			show: false, //控制弹窗
			title: '', //弹窗标题
			type: 0,

			industryCategoriesList:{ //行业类别
				value:'',
				list:[],
			},
			// industryCategoriesList: {//行业类别
			// 	value: '不限',
			// 	list: []
			// },
			loadAmountList: {
				value: '不限',
				list: []
			}, //贷款额度
			loadTimeList: {
				value: '不限',
				list: []
			}, //贷款期限
			regionList: {//所属区域
				value: '不限',
				list: []
			}, //所属区域
			dbModeList: {
				value: '不限',
				list: []
			}, //担保方式
			selectList: [{
					id: '1',
					name: '行业类别'
				},
				{
					id: '2',
					name: '所属区域'
				}
			],
			selectValue: '1',
			tabActiveIndex: 0,
			tabType: 'down',
			tabList: ['更新时间', '被对接次数', '被收藏次数'],
			hylxTabList: ['行业类别', '所属区域'],
			//分页配置
			page: {
				currentPage: 1, //当前页码
				total: 200, //总共条数
				pageSize: 20, //每页显示条数
				pageSizeList: [5, 10, 20], //每页显示条数切换
			},
			baseForm: [],
			baseForm1: { //找项目参数
				city: "",
				guaranteeType: "",
				industry: "",
				loanAmountDown: null,
				loanAmountUp: null,
				loanTermDown: null,
				loanTermUp: null,
				orders: [{
					asc: true,
					column: ""
				}],
				pageNum: 1,
                pageSize: 20,
                searchContent:"",
				searchCount: true
			},
			// baseDic:{//字典项参数
			// 	dicId:""
			// },
		}
	},
	computed: {},
	filters: {},
	methods: {

		getIndustryFn(){//获取行业字典项
			dataSource.postIndexGetIndustryDicList().then(res=>{
				if(res.data.success){
					let data = res.data.data;
					this.industryCategoriesList.list = [{itemName:"不限",itemCode:''}]
					data.map(item =>{
						this.industryCategoriesList.list.push({
							itemName: item.industryName,
							itemCode: item.industryCode
						})
					})

				}else {
					this.$message.error(res.data.msg)
				}
			}).catch(err => {});

		},
		getAreaFn(){//获取所属区域字典项
			dataSource.postIndexGetDictionaryList({dicId:"5001"}).then(res=>{
				if(res.data.success){
					let data = res.data.data;
					this.regionList.list = [{itemName:"不限",itemCode:''}]
					data.map(item =>{
						this.regionList.list.push({
							itemName: item.itemName,
							itemCode: item.itemCode
						})
					})
				}else {
					this.$message.error(res.data.msg)
				}
			}).catch(err => {});

		},
		getGuaranteeFn(){//获取担保方式字典项

			dataSource.postIndexGetDictionaryList({dicId:"1001"}).then(res=>{
				if(res.data.success){
					let data = res.data.data;
					this.dbModeList.list = [{itemName:"不限",itemCode:''}]
					data.map(item =>{
						this.dbModeList.list.push({
							itemName: item.itemName,
							itemCode: item.itemCode
						})
					})

				}else {
					this.$message.error(res.data.msg)
				}
			}).catch(err => {});

		},
		getLoanAmountFn(){//获取贷款额度字典项
			dataSource.postIndexGetDictionaryList({dicId:"3001"}).then(res=>{
				if(res.data.success){
					let data = res.data.data;
					this.loadAmountList.list = [{itemName:"不限",itemCode:'',itemLeftInterval:null,itemRightInterval:null}]
					data.map(item =>{
						this.loadAmountList.list.push({
							itemName: item.itemName,
							itemCode: item.itemCode,
							itemLeftInterval:item.itemLeftInterval,
							itemRightInterval:item.itemRightInterval
						})
					})

				}else {
					this.$message.error(res.data.msg)
				}
			}).catch(err => {});

		},
		getLoadTimeFn(){//获取贷款期限字典项
			dataSource.postIndexGetDictionaryList({dicId:"2001"}).then(res=>{
				if(res.data.success){
					let data = res.data.data;
					this.loadTimeList.list = [{itemName:"不限",itemCode:'',itemLeftInterval:null,itemRightInterval:null}]
					data.map(item =>{
						this.loadTimeList.list.push({
							itemName: item.itemName,
							itemCode: item.itemCode,
							itemLeftInterval:item.itemLeftInterval,
							itemRightInterval:item.itemRightInterval
						})
					})

				}else {
					this.$message.error(res.data.msg)
				}
			}).catch(err => {});

		},
		//找项目
		postIndexCompanyProductFn() {
			this.baseForm1.pageNum = this.page.currentPage;
            this.baseForm1.pageSize = this.page.pageSize;
			dataSource.postIndexCompanyProduct(this.baseForm1)
				.then(res => {
					if (res.data.success) {
						let data = res.data.data;
						this.baseForm = data.list;
						this.page.currentPage = data.pageNum;
						this.page.total = data.total;
						this.page.pageSize = data.pageSize;
					} else {
						this.$message.error(res.data.msg)
					}

				})
				.catch(err => {});
		},
		handleSizeChange(val) { //分页-每页显示条数切换
			this.page.pageSize = val;
			this.postIndexCompanyProductFn();
		},
		handleCurrentChange(val) { //分页-页面切换
			this.page.currentPage = val;
			this.postIndexCompanyProductFn();
		},
		changeSelect(item) { //企业属性-选择
			if (this.selectValue != item.id) {
				this.selectValue = item.id;
			}
		},
        getSelectData1(val) { //行业类别
			val.list.map(item=>{
				if(item.itemCode == val.value){
					this.baseForm1.industry = item.itemCode
				}
            })
            this.baseForm1.pageNum = this.page.currentPage = 1;
			this.postIndexCompanyProductFn();
		},
        getSelectData2(val) { //所属区域

			val.list.map(item=>{
				if(item.itemCode == val.value){
					this.baseForm1.city = item.itemCode
				}
            })
            this.baseForm1.pageNum = this.page.currentPage = 1;
			this.postIndexCompanyProductFn();
		},
		getSelectData3(val) { //贷款额度
			this.loadAmountList.list.map(item=>{
				if(item.itemCode == val.value){
					this.baseForm1.loanAmountDown = item.itemLeftInterval;
					this.baseForm1.loanAmountUp = item.itemRightInterval;
                }

            })
            this.baseForm1.pageNum = this.page.currentPage = 1;
			this.postIndexCompanyProductFn();
		},
		getSelectData4(val) { //贷款期限
			this.loadTimeList.list.map(item=>{
				if(item.itemCode == val.value){
					this.baseForm1.loanTermDown = item.itemLeftInterval;
					this.baseForm1.loanTermUp = item.itemRightInterval;
				}
            })
            this.baseForm1.pageNum = this.page.currentPage = 1;
			this.postIndexCompanyProductFn();
		},
        getSelectData5(val) { //担保方式
            this.baseForm1.guaranteeType = val.value
            this.baseForm1.pageNum = this.page.currentPage = 1;
			this.postIndexCompanyProductFn();
		},
		tabSort(index, tabType) {
			this.tabActiveIndex = index;
			//this.baseForm1.orders[0].column = this.tabList[this.tabActiveIndex];
			if (this.tabList[this.tabActiveIndex] == "更新时间") {
				this.baseForm1.orders[0].column = "updateTime";
			} else if (this.tabList[this.tabActiveIndex] == "被对接次数") {
				this.baseForm1.orders[0].column = "dockingInsCount";
			} else if (this.tabList[this.tabActiveIndex] == "被收藏次数") {
				this.baseForm1.orders[0].column = "collectionCount";
			} else {
				this.baseForm1.orders[0].column = "updateTime";
			}
			if (tabType && tabType.length > 0) {
				this.tabType = tabType;
			} else {
				this.tabType = "";
			}
			if (this.tabType == "up") {
				this.baseForm1.orders[0].asc = true;
			} else if (this.tabType == "down") {
				this.baseForm1.orders[0].asc = false;
			} else {
				this.baseForm1.orders[0].asc = true;
            }
            this.baseForm1.pageNum = this.page.currentPage = 1;
			this.postIndexCompanyProductFn();
		},
		goDetail() { //查看详情-弹窗
			this.show = true;
			this.title = "提示";
		},
		cancelHandle() { //弹窗-取消
			this.show = false;
		},
		sureHandle() { //弹窗-确定
			//let xaccessToken = localStorage.getItem('xaccessToken');
			//let bankRole = localStorage.getItem('bankRole');
			let origin = window.location.origin;
			window.open(origin + '/ordosbank/');
//			if(xaccessToken){
//				window.open(origin + '/bank/projectHallDes');
//	        	sessionStorage.setItem('projectHallDes',item.id);
//			}else{
//				window.open(origin + '/bank');
//			}
			this.show = false;
		}
	},
	created() {
		this.getIndustryFn();
		this.getAreaFn();
		this.getGuaranteeFn();
		this.postIndexCompanyProductFn();
		this.getLoanAmountFn();
		this.getLoadTimeFn();

	},
	mounted() {


	},
	activated() {}
}
